"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 16 16" id=icon-information-filled-small><path d="M8 0a8 8 0 100 16A8 8 0 008 0zm1 11a1 1 0 01-2 0V8a1 1 0 112 0v3zM8 6a1 1 0 110-2 1 1 0 010 2z"></path></symbol>';
}